import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Youtube: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            role="img"
        >
            {props.title && <title>{props.title}</title>}
            <path d="M32,0 L32,32 L0,32 L0,0 L32,0 Z M16.2609103,8.96078878 L15.7390897,8.96078878 C14.5694091,8.96631023 9.80880455,9.01048182 8.49869091,9.36385455 C7.67265455,9.58607273 7.02203636,10.2408364 6.80123636,11.0723273 C6.45349818,12.3783782 6.40713309,14.9142575 6.40095108,15.5672732 L6.40001486,15.7133324 C6.4,15.7201427 6.4,15.7236364 6.4,15.7236364 L6.40001486,15.73394 L6.40001486,15.73394 L6.40095108,15.8799944 C6.40713309,16.5329901 6.45349818,19.0688 6.80123636,20.3749455 C7.02203636,21.2064364 7.67265455,21.8612 8.49869091,22.0835273 C9.88366818,22.4569918 15.1247451,22.4850017 15.9031161,22.4871024 L16.0968839,22.4871024 C16.8752549,22.4850017 22.1163318,22.4569918 23.5013091,22.0835273 C24.3273455,21.8612 24.9779636,21.2064364 25.1987636,20.3749455 C25.5465018,19.0688 25.5928669,16.5329901 25.5990489,15.8799944 L25.5999851,15.73394 C25.6,15.7271299 25.6,15.7236364 25.6,15.7236364 L25.5999851,15.7133324 L25.5999851,15.7133324 L25.5990489,15.5672732 C25.5928669,14.9142575 25.5465018,12.3783782 25.1987636,11.0723273 C24.9779636,10.2408364 24.3273455,9.58607273 23.5013091,9.36385455 C22.1911955,9.01048182 17.4305909,8.96631023 16.2609103,8.96078878 Z M14.0363636,12.8688364 L19.0545455,15.7237455 L14.0363636,18.5784364 L14.0363636,12.8688364 Z"></path>
        </svg>
    );
};

export default React.memo(Youtube);
